import React from 'react'
import BrokerListView from 'tennders-market/common/views/lists/BrokerListView'
import { useMyBoard } from 'tennders-market/load/hooks/useMyBoard'
import { useSocketRefresh } from 'tennders-transactions/hooks/useSocketRefresh'
import { SearchTypes } from 'tennders-common/types/SearchTypes'
import TableLoadBoardSkeleton from '@/plugins/skeleton/components/TableLoadBoardSkeleton'

const BinBrokerBidView = ({ refreshKey }) => {
  const { items, onSorted, onRefresh, isLoading, pagination, initialized } = useMyBoard()
  useSocketRefresh({ refreshKey, onRefresh })

  return (
    <div className="tennders-white-box tennders-custom-scroll">
      <div className="tennders-broker-myboard-table" style={{ minHeight: 'calc(100vh - 140px)' }}>
        {isLoading && !initialized
          ? <TableLoadBoardSkeleton numberOfRows={3} /> : (
            <BrokerListView
              onSorted={onSorted}
              transactions={items}
              pagination={pagination}
              listType={SearchTypes.MY_BOARD}
            />
          ) }

      </div>
    </div>
  )
}
export default React.memo(BinBrokerBidView)
